module.exports = __webpack_public_path__ + "static/media/14(1).c1cef6d8.jpg";